import { useMutation } from '@apollo/client/react';
import { CREATE_ESNI_RULE } from '@optools/services/operator-gateway/esni/mutations';
import { ESNI_RULES } from '@optools/services/operator-gateway/esni/queries';
import { toast } from 'sonner';

import { RuleForm, RuleFormType } from './rule-form';

export interface CreateEsniRuleProps {
  onCancel: () => void;
  onCreated: () => void;
}

export function CreateEsniRule({ onCancel, onCreated }: CreateEsniRuleProps) {
  const [createEsniRule, { loading }] = useMutation(CREATE_ESNI_RULE, {
    awaitRefetchQueries: true,
    onCompleted: () => {
      toast.success('Created ESNI rule');
      onCreated();
    },
    refetchQueries: [{ query: ESNI_RULES }],
  });

  const handleSubmit = (input: RuleFormType) => {
    createEsniRule({
      variables: {
        input,
      },
    });
  };

  const handleReset = () => {
    onCancel();
  };

  return <RuleForm loading={loading} onReset={handleReset} onSubmit={handleSubmit} />;
}
